'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var errorMessages = {
    phoneNumber: 'Nomor Telepon tidak boleh kosong',
    invalidPhoneNumber: 'Nomor Telepon tidak valid',
    email: 'Email tidak boleh kosong',
    password: 'Password tidak boleh kosong',
    confirmPassword: 'Konfirmasi Password harus sama',
    otp: 'Kode OTP tidak valid',
    fullName: 'Nama Lengkap tidak boleh kosong',
    gender: 'Jenis Kelamin tidak boleh kosong',
    birthDay: 'Tanggal Lahir tidak boleh kosong',
    birthMonth: 'Bulan Lahir tidak boleh kosong',
    birthYear: 'Tahun Lahir tidak boleh kosong',
    passport: 'No. Passport tidak boleh kosong',
    ktp: 'No. KTP tidak boleh kosong',
    maxCardNumber: 'Minimal/ Maksimal 16 karakter.',
    annualIncome: 'Pendapatan tidak boleh kosong',
    sourceOfFund: 'Sumber Pendapatan tidak boleh kosong',
    type: 'Tipe harus dipilih',
};

exports.errorMessages = errorMessages;
//# sourceMappingURL=constant.js.map
